import gql from 'graphql-tag';
import { userFragment } from '../fragments';
export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["BLOCKED"] = "BLOCKED";
    UserStatus["SUSPENDED"] = "SUSPENDED";
})(UserStatus || (UserStatus = {}));
export var FrStatuses;
(function (FrStatuses) {
    FrStatuses["PENDING"] = "PENDING";
    FrStatuses["VERIFIED"] = "VERIFIED";
    FrStatuses["UNVERIFIED"] = "UNVERIFIED";
    FrStatuses["TEMPORARY_REJECTED"] = "TEMPORARY_REJECTED";
    FrStatuses["REJECTED"] = "REJECTED";
})(FrStatuses || (FrStatuses = {}));
export const meQuery = gql `
  query Me {
    me {
      hasDepositedCrypto
      ...userFields
      group {
        id
        name
      }
      agreedToMarketingMessages
      agent {
        jurisdiction {
          id
        }
      }
    }
  }

  ${userFragment}
`;
//# sourceMappingURL=user.js.map